
/**
 * SEO 配置 - models (Deutsch)
 */

export default {
    veo_3_1: {
        title: 'Google Veo 3.1 - Flaggschiff KI-Videogenerator | WeryAI',
        description: 'Google Veo 3.1: Flaggschiff KI-Videomodell mit nativem Audio.',
        keywords: 'Google Veo 3.1, KI Video, Videogenerator, WeryAI',
    },
    veo_3: {
        title: 'veo 3 KI Video- und Bildgenerierung | WeryAI',
        description: 'Experience veo 3 on WeryAI. High-quality results.',
        keywords: 'veo_3, AI, WeryAI',
    },
    veo_3_fast: {
        title: 'veo 3 fast KI Video- und Bildgenerierung | WeryAI',
        description: 'Experience veo 3 fast on WeryAI. High-quality results.',
        keywords: 'veo_3_fast, AI, WeryAI',
    },
    sora_2: {
        title: 'sora 2 KI Video- und Bildgenerierung | WeryAI',
        description: 'Experience sora 2 on WeryAI. High-quality results.',
        keywords: 'sora_2, AI, WeryAI',
    },
    weryai_video_1: {
        title: 'WeryAI Video 1.0 KI-Videogenerierung | WeryAI',
        description: 'WeryAI Video 1.0 für kinematische KI-Videos.',
        keywords: 'WeryAI Video 1.0, KI Video, WeryAI',
    },
    weryai_image_2: {
        title: 'WeryAI Image 2 - Nativer KI-Bildgenerator | WeryAI',
        description: 'Nutzen Sie WeryAI Image 2 für beeindruckende native KI-Bildgenerierung! Flaggschiff-Modell mit fortschrittlicher Stilkontrolle. Gratis Credits, keine Karte nötig.',
        keywords: 'WeryAI Image 2, nativer KI-Bildgenerator, Flaggschiff KI-Bild, Studio-Qualität KI, WeryAI Image kostenlos, wie nutzt man WeryAI Image 2, WeryAI',
    },
    image_nano_banana_2: {
        title: 'Nano Banana 2 Bildgenerator Googles neuestes | WeryAI',
        description: 'Nano Banana 2 angetrieben von Gemini mit Weltwissen und Echtzeitsuche. Generieren Sie faktisch genaue, atemberaubende Bilder mit ultraschneller Geschwindigkeit.',
        keywords: 'Nano Banana 2, Google KI, Gemini, Bildgenerierung, Textrendering, Multi-Subjekt-Konsistenz, 4K, WeryAI',
        og_title: 'Nano Banana 2 Bildgenerator | WeryAI',
        og_description: 'Nano Banana 2 wird von Gemini angetrieben mit tiefem Weltverständnis und Echtzeit-Suche und generiert Bilder, die sowohl schön als auch faktisch genau sind.',
        twitter_title: 'Nano Banana 2 Bildgenerator | WeryAI',
        twitter_description: 'Nano Banana 2 wird von Gemini angetrieben mit tiefem Weltverständnis und Echtzeit-Suche und generiert Bilder, die sowohl schön als auch faktisch genau sind.',
        ogImage: 'https://static.weryai.com/growth/image/weryai_ef98c0ea10c77d45e68553c1b6692e5b.webp',
        twitterImage: 'https://static.weryai.com/growth/image/weryai_ef98c0ea10c77d45e68553c1b6692e5b.webp',
        ogImageAlt: 'Nano Banana 2 KI-Bildgenerator',
        twitterImageAlt: 'Nano Banana 2 KI-Bildgenerator',
    },
    image_grok_2: {
        title: 'Kostenlos Grok 2 - xAI Bildgenerator | WeryAI',
        description: 'Nutzen Sie Grok 2 auf WeryAI für kreative KI-Bilder! xAI-Modell mit künstlerischer Flexibilität und einzigartigen Stilen. Gratis Credits, keine Karte nötig.',
        keywords: 'Grok 2, Grok AI, xAI Bildgenerator, KI-Kunst, kreative KI-Bilder, Grok 2 kostenlos, wie nutzt man Grok 2, WeryAI',
    },
    kling_ai: {
        title: 'kling ai KI Video- und Bildgenerierung | WeryAI',
        description: 'Experience kling ai on WeryAI. High-quality results.',
        keywords: 'kling_ai, AI, WeryAI',
    },
    runway_ai: {
        title: 'runway ai KI Video- und Bildgenerierung | WeryAI',
        description: 'Experience runway ai on WeryAI. High-quality results.',
        keywords: 'runway_ai, AI, WeryAI',
    },
    hailuo_23: {
        title: 'hailuo 23 KI Video- und Bildgenerierung | WeryAI',
        description: 'Experience hailuo 23 on WeryAI. High-quality results.',
        keywords: 'hailuo_23, AI, WeryAI',
    },
    hailuo_ai: {
        title: 'hailuo ai KI Video- und Bildgenerierung | WeryAI',
        description: 'Experience hailuo ai on WeryAI. High-quality results.',
        keywords: 'hailuo_ai, AI, WeryAI',
    },
    pika_2_2: {
        title: 'pika 2 2 KI Video- und Bildgenerierung | WeryAI',
        description: 'Experience pika 2 2 on WeryAI. High-quality results.',
        keywords: 'pika_2_2, AI, WeryAI',
    },
    seedance: {
        title: 'seedance KI Video- und Bildgenerierung | WeryAI',
        description: 'Experience seedance on WeryAI. High-quality results.',
        keywords: 'seedance, AI, WeryAI',
    },
    seedance_2: {

        title: 'Werydance 2.0 - Regisseur-Level KI-Videogenerator | WeryAI',

        description: 'Regisseur-Level KI-Videos mit Werydance 2.0: multimodale Referenzen, narrative Konsistenz und Physiksimulation. Kostenlos auf WeryAI testen.',

        keywords: 'Werydance 2.0, Seedance AI, weryai, KI-Videogenerator, Regisseur-Level Video, multimodales Video, Physiksimulation, Lippensynchronisation, Text zu Video, kostenlose KI-Videos, WeryAI',

        og_title: 'Werydance 2.0 - Regisseur-Level KI-Videogenerator | WeryAI',

        og_description: 'Regisseur-Level KI-Videos mit Werydance 2.0: multimodale Referenzen, narrative Konsistenz und Physiksimulation. Kostenlos auf WeryAI testen.',

        twitter_title: 'Werydance 2.0 - Regisseur-Level KI-Videogenerator | WeryAI',

        twitter_description: 'Regisseur-Level KI-Videos mit Werydance 2.0: multimodale Referenzen, narrative Konsistenz und Physiksimulation. Kostenlos auf WeryAI testen.',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Werydance 2.0 AI Video Generator',

        twitterImageAlt: 'Werydance 2.0 AI Video Generator',

    },
    wan_2_6: {
        title: 'Wan 2.6 Fortgeschrittener KI-Video-Generator | WeryAI',
        description: 'Wan 2.6 ist Alibabas neuestes multimodales Flaggschiffmodell zur KI-Videogenerierung – mit kinoreifer 1080p-Qualität, nativer Audio-Video-Synchronisation und intelligenten Multi-Shot-Storytelling-Funktionen. Gratis auf WeryAI testen.',
        keywords: 'Wan 2.6, Alibaba Wan 2.6, KI Video Generator, multimodales Videomodell, Text zu Video, Bild zu Video, Audio-Synchronisation, WeryAI Wan 2.6',
    },
    image_gpt_4o: {
        title: 'Kostenlos GPT-4o - OpenAI Bildgenerator testen | WeryAI',
        description: 'Nutzen Sie GPT-4o auf WeryAI um Bilder per Konversation zu erstellen! OpenAI mit präzisem Textrendering und High-Fidelity-Ergebnissen. Gratis Credits, keine Karte nötig.',
        keywords: 'GPT-4o, GPT-4o Bild, OpenAI Bildgenerator, konversationelle KI-Kunst, GPT-4o kostenlos, wie nutzt man GPT-4o Bilder, WeryAI',
    },
    image_nano_banana_pro: {
        title: 'Kostenlos Nano Banana Pro - KI-Bildgenerator | WeryAI',
        description: 'Nutzen Sie Nano Banana Pro auf WeryAI für höchste KI-Bildqualität! Konkurriert mit Midjourney bei überlegener Prompt-Treue. Gratis Credits, keine Karte nötig.',
        keywords: 'Nano Banana Pro, Gemini 3.0 Pro, Google KI-Bild, Reasoning-KI-Bild, 4K KI-Bild, Nano Banana Pro kostenlos, wie nutzt man Nano Banana Pro, WeryAI',
    },
    image_nano_banana: {
        title: 'Kostenlos Nano Banana - KI-Bildgenerator | WeryAI',
        description: 'Nutzen Sie Nano Banana auf WeryAI um einfach KI-Bilder zu erstellen! Vielseitiges und schnelles KI-Bildmodell. Gratis Credits, keine Karte nötig.',
        keywords: 'Nano Banana, Gemini 2.5 Flash, Google KI-Bild, schneller KI-Bildgenerator, Charakter-Konsistenz, Nano Banana kostenlos, wie nutzt man Nano Banana, WeryAI',
    },
    image_flux: {
        title: 'Kostenlos FLUX - KI-Bildgenerator testen | WeryAI',
        description: 'Nutzen Sie FLUX auf WeryAI für beeindruckende KI-Bilder! Vom Stable Diffusion Team mit herausragender Qualität und Stilkontrolle. Gratis Credits, keine Karte nötig.',
        keywords: 'FLUX, FLUX AI, Black Forest Labs, KI-Bildgenerator, Text zu Bild, KI-Kunst, FLUX kostenlos, wie nutzt man FLUX, WeryAI',
    },
    image_flux_kontext: {
        title: 'Kostenlos FLUX Kontext - Profi-KI-Bildeditor | WeryAI',
        description: 'Nutzen Sie FLUX Kontext auf WeryAI für professionelle KI-Bildbearbeitung! Überlegene Prompt-Treue, fortgeschrittene Typografie und mehrstufige Bearbeitung. Gratis Credits, keine Karte nötig.',
        keywords: 'FLUX Kontext, FLUX.1 Kontext, KI-Bildeditor, Profi-KI-Bild, Typografie-KI, FLUX Kontext kostenlos, wie nutzt man FLUX Kontext, WeryAI',
    },
    image_imagen: {
        title: 'Kostenlos Imagen 4 - Google KI-Bildgenerator | WeryAI',
        description: 'Nutzen Sie Google Imagen 4 auf WeryAI für fotorealistische KI-Bilder! Vielseitige Stilkontrolle und präzise Textgenerierung. Gratis Credits, keine Karte nötig.',
        keywords: 'Imagen 4, Google Imagen, Google KI-Bildgenerator, Text zu Bild, fotorealistische KI, Imagen kostenlos, wie nutzt man Imagen 4, WeryAI',
    },
    image_qwen_image: {
        title: 'Kostenlos Qwen Image - Alibaba KI-Bildmodell | WeryAI',
        description: 'Nutzen Sie Qwen Image auf WeryAI für mehrsprachige KI-Kunst! Alibabas Open-Source-Modell mit überlegenem Textrendering. Gratis Credits, keine Karte nötig.',
        keywords: 'Qwen Image, Alibaba AI, Open-Source KI-Bild, mehrsprachiges Textrendering, Qwen Image kostenlos, wie nutzt man Qwen Image, WeryAI',
    },
    image_wan_ai: {
        title: 'Kostenlos Wan AI - Alibaba Bildgenerator testen | WeryAI',
        description: 'Nutzen Sie Wan AI auf WeryAI für hochauflösende KI-Bilder! Alibaba-Modell mit präziser Prompt-Verfolgung und fotorealistischem Rendering. Gratis Credits, keine Karte nötig.',
        keywords: 'Wan AI, Wan 2.5, Alibaba KI-Bildgenerator, Text zu Bild, fotorealistische KI, Wan AI kostenlos, wie nutzt man Wan AI, WeryAI',
    },
    image_seendream: {
        title: 'Kostenlos Seedream 4.0 - ByteDance Bild-KI | WeryAI',
        description: 'Nutzen Sie Seedream 4.0 auf WeryAI für ultraschnelle KI-Bildgenerierung! ByteDance-Modell mit vielfältigen Kunststilen. Gratis Credits, keine Karte nötig.',
        keywords: 'Seedream, Seedream 4.0, ByteDance KI-Bild, ultraschnelle KI-Bilder, künstlerische KI-Stile, Seedream kostenlos, wie nutzt man Seedream, WeryAI',
    },
    image_dreamina: {
        title: 'Kostenlos Dreamina 4.0 - Multimodale Bild-KI | WeryAI',
        description: 'Nutzen Sie Dreamina 4.0 auf WeryAI für multimodale KI-Bilderstellung! Skizze-zu-Bild, Stiltransfer und Charakterfusion. Gratis Credits, keine Karte nötig.',
        keywords: 'Dreamina 4.0, ByteDance KI-Bild, multimodale KI-Bilder, Skizze zu Bild, Stiltransfer, Dreamina kostenlos, wie nutzt man Dreamina 4.0, WeryAI',
    },
    image_seedream_4_5: {
        title: 'Kostenlos Seedream 4.5 - ByteDance Bild-KI | WeryAI',
        description: 'Nutzen Sie Seedream 4.5 auf WeryAI für Flaggschiff-KI-Bildgenerierung! ByteDances neuestes mit präziser Typografie und Multi-Bild-Fusion. Gratis Credits, keine Karte nötig.',
        keywords: 'Seedream 4.5, ByteDance KI-Bild, Flaggschiff-KI-Bildmodell, Typografie-Rendering, Multi-Bild-Fusion, Seedream 4.5 kostenlos, wie nutzt man Seedream 4.5, WeryAI',
    },
    image_seedream_5_0: {
        title: 'Seedream 5.0 ByteDance Ultimatives | WeryAI',
        description: 'Seedream 5.0 ist ByteDances Meisterwerk im KI-Visualbereich mit nativer 8K-Qualität, ultimativem semantischen Verständnis, Multi-Subjekt-Komposition und Textrendering 2.0. Kostenlos auf WeryAI testen.',
        keywords: 'Seedream 5.0, KI-Bildgenerierung, 8K-Qualität, semantisches Verständnis, Multi-Subjekt-Komposition, Textrendering, ByteDance, WeryAI',
        og_title: 'Seedream 5.0 Bildgenerator | WeryAI',
        og_description: 'Seedream 5.0 ist ByteDances Spitzenmodell für KI-Visualisierung mit nativer 8K-Qualität, fortschrittlichem semantischem Verständnis, Multi-Subjekt-Komposition und verbessertem Text-Rendering.',
        twitter_title: 'Seedream 5.0 Bildgenerator | WeryAI',
        twitter_description: 'Seedream 5.0 ist ByteDances Spitzenmodell für KI-Visualisierung mit nativer 8K-Qualität, fortschrittlichem semantischem Verständnis, Multi-Subjekt-Komposition und verbessertem Text-Rendering.',
        ogImage: 'https://static.weryai.com/growth/image/weryai_871e99f0d8f52b7abdb1d410e76ae64d.png',
        twitterImage: 'https://static.weryai.com/growth/image/weryai_871e99f0d8f52b7abdb1d410e76ae64d.png',
        ogImageAlt: 'Seedream 5.0 KI-Bildgenerator',
        twitterImageAlt: 'Seedream 5.0 KI-Bildgenerator',
    },
    image_recraft_v4_vector: {
        title: 'Recraft V4 Vector - Professioneller KI-Vektorgrafik-Generator | WeryAI',
        description: 'Recraft V4 Vector ist ein professioneller KI-Vektorgrafik-Generator von Recraft.ai, der bearbeitbare SVG-Vektoren mit verlustfreier Skalierung, präziser Typografie und Markenstil-Kontrolle generiert. Jetzt kostenlos auf WeryAI testen.',
        keywords: 'Recraft V4 Vector, KI-Vektorgenerierung, SVG-Generator, echter Vektor, Logo-Design, UI-Icons, Vektorillustration, Recraft, WeryAI',
    },
    image_midjourney: {
        title: 'Kostenlos Midjourney - KI-Kunstgenerator testen | WeryAI',
        description: 'Nutzen Sie Midjourney auf WeryAI für künstlerische KI-Bilder! Berühmt für beeindruckende Ästhetik und Beleuchtungsqualität. Gratis Credits, keine Karte nötig.',
        keywords: 'Midjourney, Midjourney AI, KI-Kunstgenerator, künstlerische KI-Bilder, Midjourney kostenlos, Midjourney Alternative, wie nutzt man Midjourney, WeryAI',
    },
    runway_4_5: {
        title: 'Runway Gen-4.5 KI-Video-Generator | WeryAI',
        description: 'Erstellen Sie beeindruckende Videos mit Runway Gen-4.5 auf WeryAI. Autoregressive-Diffusion-Hybridarchitektur für präzise Physiksimulation und zeitliche Konsistenz.',
        keywords: 'Runway Gen-4.5, KI-Video-Generator, kinoreifes KI-Video, Physiksimulation, Runway AI, WeryAI',
    },
    kling_2_6_pro: {
        title: 'Kling 2.6 Pro KI-Video-Generator | WeryAI',
        description: 'Generieren Sie hochwertige Videos mit Kling 2.6 Pro auf WeryAI. Native audiovisuelle Generierung, kinoreife 1080p-Qualität, hervorragende Prompt-Befolgung.',
        keywords: 'Kling 2.6 Pro, KI-Video-Generator, hochwertiges KI-Video, Kling AI, WeryAI',
    },
    video_dreamina_3: {
        title: 'Dreamina 3.0 Video-Generator Präzise | WeryAI',
        description: 'Generieren Sie kinoreife KI-Videos mit Dreamina 3.0 (Jimeng 3.0) auf WeryAI. Präzise Start/End-Frame-Steuerung, professionelle Kamerabewegungen und 1080p-Hochdynamik-Videogenerierung.',
        keywords: 'Dreamina 3.0, Jimeng Video 3.0, KI-Video-Generator, Kamerasteuerung, Start-End-Frame, ByteDance AI, WeryAI',
    },
    kling_o1: {
        title: 'Kling O1 KI-Video-Generator Kreative | WeryAI',
        description: 'Entfesseln Sie Ihre Kreativität auf WeryAI mit dem Kling O1 KI-Video-Generator. Perfekt für die Generierung fantasievoller und einzigartiger Videoinhalte.',
        keywords: 'Kling O1, KI-Video-Generator, kreatives KI-Video, Kling AI, WeryAI',
    },
    kling_3_0: {

        title: 'Kling 3.0 - Intelligenter KI-Videogenerator | WeryAI',

        description: 'KI-Videos erstellen mit Kling 3.0: intelligentes Storyboarding, mehrsprachige Lippensynchronisation und präzises Textrendering. Kostenlos auf WeryAI.',

        keywords: 'Kling 3.0, Kling AI, Kuaishou, KI-Videogenerator, intelligentes Storyboarding, Lippensynchronisation, Textrendering, Text zu Video, Bild zu Video, kostenlose KI-Videos, WeryAI',

        og_title: 'Kling 3.0 - Intelligenter KI-Videogenerator | WeryAI',

        og_description: 'KI-Videos erstellen mit Kling 3.0: intelligentes Storyboarding, mehrsprachige Lippensynchronisation und präzises Textrendering. Kostenlos auf WeryAI.',

        twitter_title: 'Kling 3.0 - Intelligenter KI-Videogenerator | WeryAI',

        twitter_description: 'KI-Videos erstellen mit Kling 3.0: intelligentes Storyboarding, mehrsprachige Lippensynchronisation und präzises Textrendering. Kostenlos auf WeryAI.',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Kling 3.0 AI Video Generator',

        twitterImageAlt: 'Kling 3.0 AI Video Generator',

    },
    vidu_q3: {

        title: 'Vidu Q3 - Natives 16s Audio-Video KI-Generator | WeryAI',

        description: 'Natives 16-Sekunden-Audio-Video mit Vidu Q3 generieren: Smart Cuts, präzises Textrendering und mehrsprachige Lip-Sync. Kostenlos auf WeryAI.',

        keywords: 'Vidu Q3, Vidu AI, KI-Videogenerator, natives 16s Audio-Video, intelligentes Storyboarding, Textrendering, Lippensynchronisation, Text zu Video, Bild zu Video, kostenlose KI-Videos, WeryAI',

        og_title: 'Vidu Q3 - Natives 16s Audio-Video KI-Generator | WeryAI',

        og_description: 'Natives 16-Sekunden-Audio-Video mit Vidu Q3 generieren: Smart Cuts, präzises Textrendering und mehrsprachige Lip-Sync. Kostenlos auf WeryAI.',

        twitter_title: 'Vidu Q3 - Natives 16s Audio-Video KI-Generator | WeryAI',

        twitter_description: 'Natives 16-Sekunden-Audio-Video mit Vidu Q3 generieren: Smart Cuts, präzises Textrendering und mehrsprachige Lip-Sync. Kostenlos auf WeryAI.',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Vidu Q3 AI Video Generator',

        twitterImageAlt: 'Vidu Q3 AI Video Generator',

    },
    image_gpt_image_1_5: {
        title: 'Kostenlos GPT Image 1.5 - OpenAI Kunstgenerator | WeryAI',
        description: 'Nutzen Sie GPT Image 1.5 auf WeryAI für KI-Kunst der nächsten Generation! OpenAIs neuestes Bildmodell mit verbesserter Kreativität. Gratis Credits, keine Karte nötig.',
        keywords: 'GPT Image 1.5, OpenAI Bildmodell, KI-Kunstgenerator, Next-Gen KI-Bild, GPT Image 1.5 kostenlos, wie nutzt man GPT Image 1.5, WeryAI',
    },
}
